import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderPrayVote2020 from "../../../../src/content/pray-vote-engage-2020/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderPrayVote2020,
  React
};